import { render, staticRenderFns } from "./NoLists.vue?vue&type=template&id=0a437cff"
import script from "./NoLists.vue?vue&type=script&lang=js"
export * from "./NoLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports